<template>
  <nav class="navbar navbar-expand-lg navbar-light py-2">
    <span class="navbar-brand">
      <img
        :alt="headerLogoAlt"
        :height="headerLogoHeight"
        :src="headerLogoSrc"
        :width="headerLogoWidth"
      >
    </span>
  </nav>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        headerLogoAlt: 'brand/headerLogoAlt',
        headerLogoHeight: 'brand/headerLogoHeight',
        headerLogoSrc: 'brand/headerLogoSrc',
        headerLogoWidth: 'brand/headerLogoWidth'
      })
    }
  };
</script>
